export const environment = {
  production: true,
  mocking: false
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/environments/environment.ts